export default function Loader({
  size = '16px',
  stroke = '#fff',
  strokeWidth = 2.5,
  className,
  ...rest
}: {
  size?: string
  stroke?: string
  strokeWidth?: number
  className?: string
  [k: string]: any
}) {
  return (
    <svg
      className={`animate-spin ${className || ''}`}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2,12 a10,10 0 0,1 10,-10 M12,22 a10,10 0 0,1 -10,-10 M22,12 a10,10 0 0,1 -10,10"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}